import { loadStripe } from "@stripe/stripe-js";

export const STRIPE_PROMISE = loadStripe(window.STRIPE_KEY);